import { Routes, Theme, Users } from "@just-in-types";
import { NavigateFn } from "@reach/router";
import * as moment from "moment";
import * as React from "react";
import styled from "react-emotion";
import { connect } from "react-redux";
import Container from "../components/Container";
import LoaderButton from "../components/LoaderButton";
import Row from "../components/Row";
import Text from "../components/Text";
import Title from "../components/Title";
import ErrorBoundary from "../hoc/withErrorBoundary";
import { RouteComponentProps } from "../Site";
import {
  navigateToNext,
  NavigateToNext,
  setUpdatingMode,
  SetUpdatingMode,
} from "../store/actions";
import { IState } from "../store/reducers";
import { IStrings } from "../store/reducers/strings";

interface ICouponGoalDispatchProps {
  onNavigateToNext: NavigateToNext;
  onSetUpdatingMode: SetUpdatingMode;
}

interface ICouponGoalOwnProps extends RouteComponentProps {
  bussiness: any;
  businessId: string;
  navigate: NavigateFn;
  siteId: string;
}

interface ICouponGoalStateProps {
  languageStrings: IStrings;
  rootPath?: string;
  routes: Routes.RoutesObject;
  showCoupons: boolean;
  theme: Theme.Props;
  user: Users.User;
  userTemp: IState["userTemp"];
}

type CouponGoalProps = ICouponGoalDispatchProps &
  ICouponGoalOwnProps &
  ICouponGoalStateProps;

interface ICouponGoalState {
  expired: boolean;
  sending: boolean;
  showCoupons: boolean;
  checkInsLeftText: string | null;
  rewardText: string | null;
}

const ThanksContainer = styled(Container)`
  grid-template-rows: 1fr 2fr 1fr;
`;
ThanksContainer.displayName = "ThanksContainer";

interface ICouponGoalProps {
  color: any;
}
const ThanksText = styled(Text)`
  max-width: 50vw;
  color: ${(props: ICouponGoalProps) => props.color || "rgb(252, 182, 18)"};
`;

class CouponGoal extends React.Component<CouponGoalProps, ICouponGoalState> {
  public state: ICouponGoalState = {
    checkInsLeftText: null,
    expired: false,
    rewardText: null,
    sending: false,
    showCoupons: false,
  };
  public timeout: null | NodeJS.Timer = null;

  public componentDidMount() {
    this.init();
  }

  public init = async () => {
    await this.userReward();

    if (this.hasCheckedInToday()) {
      this.setState({ expired: true });
    }
  };

  public userReward = async () => {
    const { user, onNavigateToNext } = this.props;

    if (user.userRewardText) {
      const rewardText = user.userRewardText;
      this.setState({ rewardText });
    } else {
      onNavigateToNext();
    }
  };

  public render() {
    const {
      languageStrings: strings,
      onNavigateToNext,
      theme: { colors },
    } = this.props;
    const currentUser = this.props.user;

    currentUser.name.displayName = "";

    const {
      // expired,
      rewardText,
      sending,
    } = this.state;

    const expired = false;

    return (
      <ErrorBoundary>
        <ThanksContainer>
          <Row align="center" justify="center">
            {expired && currentUser.name.displayName ? (
              <Title color={colors.warning}>
                {strings.welcomeBackThanks}, {currentUser.name.displayName}!
              </Title>
            ) : !expired && currentUser.name.displayName ? (
              <Title color={colors.warning}>
                {strings.welcomeBackThanksIf}, {currentUser.name.displayName}!
              </Title>
            ) : expired && !currentUser.name.displayName ? (
              <Title color={colors.warning}>{strings.welcomeBackThanks}!</Title>
            ) : (
              <Title color={colors.secondary}>
                {strings.welcomeBackThanksIf}!
              </Title>
            )}
          </Row>

          {rewardText ? (
            <div style={{ textAlign: "center" }}>
              <ThanksText
                color={colors.secondary}
                textAlign="center"
                size="2rem"
              >
                {rewardText}
              </ThanksText>
            </div>
          ) : null}

          <Row align="center" justify="center">
            <LoaderButton
              bg={colors.success}
              disabled={sending}
              loading={sending}
              onClick={() => onNavigateToNext()}
            >
              {strings.nextCouponGoal}
            </LoaderButton>
          </Row>
        </ThanksContainer>
      </ErrorBoundary>
    );
  }

  private hasCheckedInToday = () => {
    const {
      user: { mobile },
      userTemp: { checkIns },
    } = this.props;

    return checkIns.some(({ timestamp }) =>
      moment(timestamp.toDate()).isSame(moment(), "day")
    );
  };
}

const mapStateToProps = ({
  router: { rootPath, languageStrings, routes, showCoupons },
  theme,
  user,
  userTemp,
}: IState) => ({
  languageStrings,
  rootPath,
  routes,
  showCoupons,
  theme,
  user,
  userTemp,
});

const mapDispatchToProps = {
  onNavigateToNext: navigateToNext,
  onSetUpdatingMode: setUpdatingMode,
};

export default connect<
  ICouponGoalStateProps,
  ICouponGoalDispatchProps,
  ICouponGoalOwnProps
>(
  mapStateToProps,
  mapDispatchToProps
)(CouponGoal);



// WEBPACK FOOTER //
// ./src/views/CouponGoal.tsx